import React from 'react'
import { directionLabel } from '../utils/utils';
import arrow from '../arrow.svg';

class WaveDirection extends React.Component {

  render() {
    let waveDirection;
    if (this.props.data.value !== null && this.props.data.age < this.props.maxAge) {
      const label = directionLabel(this.props.data.value);
      const styles = {
        transform: `rotate(${this.props.data.value - 180}deg)`
      };
      waveDirection = (
        <div className="direction">
          <div>
            <img src={arrow} alt={label} style={styles} />
          </div>
          <div>
            {label} {this.props.data.value}&deg;
          </div>
        </div>);
    } else {
      waveDirection = <div className="direction nodata">-</div>;
    }
    return (
      <div>
        {waveDirection}
      </div>
    );
  }

}

export default WaveDirection;



// WEBPACK FOOTER //
// ./src/Components/WaveDirection.jsx